module.exports = __webpack_public_path__ + "static/doppel_bestaetigen-838a898246e1e65c0e0b6ba2e2ce7cef.jpg";